import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"
import moment from 'moment';
import _ from "lodash";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import coloredCorrespondent from "../../assets/images/svg/correspondent_color.svg"
import Modal from "components/RopikCustom/Modal";

import { companyListCall, contractWriteHistory, contractWriteResponse, getMemberSignFile, getMultiChildCompany } from "crud/auth.crud";
import FilePreview from "components/RopikCustom/FilePreview";
import SelectBox from "components/RopikCustom/SelectBox";

const dayArr = Array.from({ length: 28 }, (_, i) => ({
  id: i + 1,
  name: i + 1,
}));

const ContractWrite = () => {
  const history = useHistory()
  const selector = useSelector(state => state)
  const companyData = selector.auth?.user?.member_group?.[0]?.company_group;

  const [inputItem, setInputItem] = useState({
    emitter: companyData.type === 'emitter' ? companyData : {},
    collection: companyData.type === 'collection' ? companyData : {},
    treatmentList: companyData.type === 'treatment' ? [companyData] : [],
    emitterChildList: [],
    treatmentPrice : 0,
    pricePerL : 0,
    pricePerKg : 0,
    settlementDate : 1
  })
  const [modalShow, setModalShow] = useState({
    emitter: false,
    collection: false,
    treatment: false,
    emitterChild: false
  })
  const [signFile, setSignFile] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [emitterCompanyList, setEmitterCompanyList] = useState([])
  const [collectionCompanyList, setCollectionCompanyList] = useState([])
  const [treatmentCompanyList, setTreatmentCompanyList] = useState([])
  const [emitterChildCompanyList, setEmitterChildCompanyList] = useState([]);
  const [emitterSearch, setEmitterSearch] = useState('')
  const [collectionSearch, setCollectionSearch] = useState('')
  const [treatmentSearch, setTreatmentSearch] = useState('')
  const [page, setPage] = useState(1)
  const [contractFiles, setContractFiles] = useState([]);
  const [previewImages, setPreviewImages] = useState([])

  const [isHover, setIsHover] = useState(false); // 계약처 선택 시 마우스 호버 상태

  const style = { backgroundColor: "#ffffff", padding: "0.5rem", cursor: "pointer", width: '466px', border: '1px solid #bdbdbd', marginTop: '0.5rem', borderRadius: '4px', color: '#333' };

  const hoverStyle = { backgroundColor: "#4DBBAA", color: "#ffffff", width: '466px', border: '1px solid #4DBBAA' };

  const resetInputCondition = () => {
    setInputItem({
      emitter: companyData.type === 'emitter' ? companyData : {},
      collection: companyData.type === 'collection' ? companyData : {},
      treatmentList: companyData.type === 'treatment' ? [companyData] : [],
      emitterChildList: [],
    })
  }

  const changeInputCondition = (key, value) => {
    setInputItem(prev => ({ ...prev, [key]: value }))
  }

  const isValidated = () => {
    if (!inputItem.emitter || _.isEmpty(inputItem.emitter)) {
      alert("배출자를 선택해주세요")
      return false
    }
    if (inputItem.emitter?.company_detail?.[0]?.type === 'multi' && inputItem.emitterChildList.length === 0) {
      alert("계약할 지점을 선택해주세요")
      return false
    }
    if (!inputItem.collection || _.isEmpty(inputItem.collection)) {
      alert("수거업체를 선택해주세요")
      return false
    }
    if (!inputItem.treatmentList || inputItem.treatmentList.length === 0) {
      alert("처리장을 추가해주세요")
      return false
    }
    if (inputItem.pricePerL === '') {
      alert("L당 수거 가격을 입력해주세요")
      return false
    }
    if (inputItem.pricePerKg === '') {
      alert("kg당 처리 가격을 입력해주세요")
      return false
    }
    if (inputItem.minPrice === '') {
      alert("수거 기본요금을 입력해주세요")
      return false
    }
    if (inputItem.subject === '') {
      alert("제목을 입력해주세요")
      return false
    }

    return true
  }

  const saveContract = async () => {
    setIsLoading(true)

    try {
      const fd = new FormData();

      for (let i = 0; i < contractFiles.length; i++) {
        let newFile = new File([contractFiles[i]], `${encodeURI(contractFiles[i].name)}`, { type: contractFiles[i].type })
        fd.append('file_' + i, newFile);
      }

      let contractCompanyGroupData = {}

      if (inputItem.emitter?.company_detail?.[0]?.type === 'multi') {
        contractCompanyGroupData = {
          company: [...inputItem.emitterChildList, inputItem.collection, ...inputItem.treatmentList]
        }
      } else {
        contractCompanyGroupData = {
          company: [inputItem.emitter, inputItem.collection, ...inputItem.treatmentList]
        }
      }
      fd.append('contract_company_group_data', JSON.stringify(contractCompanyGroupData))

      const contractData = {
        company: companyData?.id,
        start_date: inputItem.startDate,
        end_date: inputItem.endDate,
        subject: inputItem.subject,
        content: inputItem.content,
        price_per_l: parseInt(inputItem.pricePerL),
        price_per_kg: parseInt(inputItem.pricePerKg),
        min_price: parseInt(inputItem.minPrice),
        state: 'N',
        status: 'Y',
        settlement_date: inputItem.settlementDate
      }
      fd.append('contract_data', JSON.stringify(contractData))

      const response = await contractWriteResponse(fd);
      if (response.data?.result === 'success') {
        const params = {
          contract_id: response.data?.data?.id,
          company_id: companyData?.id,
          target_company_id: JSON.stringify(inputItem.treatmentList),
          start_date: inputItem.startDate,
          end_date: inputItem.endDate,
          subject: inputItem.subject,
          content: inputItem.content,
          state: 'N',
          status: 'Y',
        }
        const rsHistory = await contractWriteHistory(params)
        setIsLoading(false)
        alert(response.data.msg)
        history.push('/contract-management-screen')
      } else {
        setIsLoading(false)
      }

    } catch (e) {
      setIsLoading(false)
      console.log("catch(e) :: ", e);
    }
  }

  const modalOpen = (key) => {
    setModalShow(prev => ({ ...prev, [key]: true }))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({ ...prev, [key]: false }))
  }

  const getSignFile = async () => {
    setIsLoading(true)
    const response = await getMemberSignFile()
    if (response?.data?.result === 'success') {
      setSignFile(response.data?.data?.[0] || {})
    }
    setIsLoading(false)
  }

  const getCompanyList = async (type, setter, search) => {
    const params = {
      page: page,
      type: type,
      search: search,
    }

    try {
      const rs = await companyListCall(params)
      if (rs.status !== 200)
        return

      const { count, results } = rs.data || {}
      if (!results) {
        setter([])
        return
      }
      if (count <= 15) {
        setter(results)
        return
      }

      let allResults = [...results]
      const totalPages = Math.ceil(count / 15)

      for (let i = 2; i <= totalPages; i++) {
        const response = await companyListCall({
          page: i,
          type: type,
          search,
        })
        if (response.status === 200 && response?.data?.results) {
          allResults = [...allResults, ...response.data.results];
        }
      }
      setter(allResults);

    } catch (error) {
      console.error(error);
      setter([])
    }
  }

  const getChildCompanyList = async (id) => {
    const rs = await getMultiChildCompany(id);
    if (rs.data?.result === 'success') {
      const content = rs?.data?.data
      setEmitterChildCompanyList([...content])
    }
  }

  const handleFileChange = (event) => {
    const files = event.target.files;
    let prevTmp = [];
    for (let i = 0; i < files.length; i++) {
      let item = {
        name: files[i].name,
        path: URL.createObjectURL(files[i]),
      }
      prevTmp.push(item)
    }
    let tmp = [...contractFiles, ...files];
    tmp = tmp.filter((v, i) => { return i - 5 < 0 })
    setContractFiles(tmp)
    prevTmp = prevTmp.filter((v, i) => { return i - 5 < 0 })
    setPreviewImages(prevTmp);
  }

  const deleteImage = (index) => {
    setContractFiles(contractFiles.filter((v, i) => { return i !== index; }))
    setPreviewImages(previewImages.filter((v, i) => { return i !== index; }))
  }

  useEffect(() => {
    getSignFile()
    companyData.type !== 'emitter' && getCompanyList('emitter', setEmitterCompanyList, '')
    companyData.type !== 'collection' && getCompanyList('collection', setCollectionCompanyList, '')
    companyData.type !== 'treatment' && getCompanyList('treatment', setTreatmentCompanyList, '')
  }, [])

  useEffect(() => {
    if (inputItem.emitter?.company_detail?.[0]?.type === 'multi') {
      getChildCompanyList(inputItem.emitter.id)
    }
  }, [inputItem.emitter])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>계약관리 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="계약관리" breadcrumbItem="계약 상세" />

          <div className="d-flex align-items-center margin-bottom-12">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">계약 정보</p>
          </div>

          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약명</td>
                          <td colSpan="4" className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.subject} placeholder="계약명을 입력해 주세요." onChange={(e) => {
                              changeInputCondition('subject', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약일자</td>
                          <td className="w-40">{moment(new Date()).format('YYYY-MM-DD')}</td>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약기간</td>
                          <td className="w-40">
                            <input className="waver-input-box w-40 border-radius-0 margin-right-4" type="date" value={inputItem.startDate} onChange={(e) => {
                              changeInputCondition('startDate', e.target.value);
                            }} />
                            <input className="waver-input-box w-40 border-radius-0" type="date" value={inputItem.endDate} onChange={(e) => {
                              changeInputCondition('endDate', e.target.value);
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">L당 요금</td>
                          <td className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.pricePerL} placeholder="L당 요금을 입력해 주세요." onChange={(e) => {
                              changeInputCondition('pricePerL', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">Kg당 요금</td>
                          <td className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.pricePerKg} placeholder="Kg당 요금을 입력해 주세요." onChange={(e) => {
                              changeInputCondition('pricePerKg', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">처리가격</td>
                          <td className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.treatmentPrice} placeholder="처리가격을 입력해 주세요." onChange={(e) => {
                              changeInputCondition('treatmentPrice', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">결산일</td>
                          <td className="w-40">
                            <SelectBox
                              value={inputItem?.settlementDate}
                              onChange={changeInputCondition}
                              options={dayArr}
                              keyValue={'settlementDate'}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">기본요금</td>
                          <td className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.minPrice} placeholder="기본요금을 입력해 주세요." onChange={(e) => {
                              changeInputCondition('minPrice', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약여부</td>
                          <td className="w-40" style={{ color: 'red' }}>
                            계약 진행중
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 내용</td>
                          <td colSpan="4" className="w-40">
                            <textarea className="waver-text-box w-100 font-size-12 border-radius-0" placeholder="내용을 입력해 주세요" value={inputItem.content}
                              onChange={(e) => {
                                changeInputCondition('content', e.target.value);
                              }} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div className="d-flex align-items-center margin-bottom-12 margin-top-38">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">계약 상대</p>
          </div>

          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">배출자</td>
                          <td className="w-90">
                            <div className="d-flex align-items-center">
                              {companyData.type !== 'emitter' &&
                                <button type="button" className="custom-btn secondary-bg border-radius-0 white-text border-none" onClick={() => {
                                  setEmitterSearch('')
                                  modalOpen('emitter')
                                }}>
                                  배출자 선택
                                </button>
                              }
                              {!_.isEmpty(inputItem.emitter) &&
                                <div style={{ minWidth: 113, height: 30, marginRight: 8, backgroundColor: '#219EBC', display: 'flex', justifyContent: "space-between", paddingLeft: 11, paddingRight: 11, alignItems: "center", gap: 8 }}>
                                  <p className="noMargin" style={{ color: "white", lineHeight: '100%' }}>{inputItem.emitter.name}</p>
                                  {companyData.type !== 'emitter' &&
                                    <p className="noMargin" style={{ color: "white", cursor: "pointer", lineHeight: '100%' }} onClick={() => {
                                      changeInputCondition('emitter', {})
                                    }}>X</p>
                                  }
                                </div>
                              }
                            </div>
                          </td>
                        </tr>
                        {((companyData.type === 'emitter' && companyData?.company_detail?.[0]?.type === 'multi') || (companyData !== 'emitter' && inputItem.emitter?.company_detail?.[0]?.type === 'multi')) &&
                          <tr>
                            <td className="w-10 padding-left-8 primary-bg white-text">본점 및 지점<br />(* 다수사업장은 선택한 본점 및 지점만 계약됩니다.)</td>
                            <td className="w-90">
                              <div className="d-flex align-items-center">
                                <button type="button" className="custom-btn secondary-bg border-radius-0 white-text border-none" onClick={() => {
                                  modalOpen('emitterChild')
                                }}>
                                  본점 및 지점 선택
                                </button>
                                {inputItem.emitterChildList.map((item, index) => (
                                  <div key={'emitter_child_company_' + index} style={{ minWidth: 113, height: 30, marginRight: 8, backgroundColor: '#219EBC', display: 'flex', justifyContent: "space-between", paddingLeft: 11, paddingRight: 11, alignItems: "center", gap: 8 }}>
                                    <p className="noMargin" style={{ color: "white", lineHeight: '100%' }}>{item.name}</p>
                                    <p className="noMargin" style={{ color: "white", cursor: "pointer", lineHeight: '100%' }} onClick={() => {
                                      changeInputCondition('emitterChildList', inputItem.emitterChildList.filter(i => i.id !== item.id))
                                    }}>X</p>
                                  </div>
                                ))}
                              </div>
                            </td>
                          </tr>
                        }
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">수거운반업체</td>
                          <td className="w-90">
                            <div className="d-flex align-items-center">
                              {companyData.type !== 'collection' &&
                                <button type="button" className="custom-btn secondary-bg border-radius-0 white-text border-none" onClick={() => {
                                  setCollectionSearch('')
                                  modalOpen('collection')
                                }}>
                                  수거운반업체 선택
                                </button>
                              }
                              {!_.isEmpty(inputItem.collection) &&
                                <div style={{ minWidth: 113, height: 30, marginRight: 8, backgroundColor: '#219EBC', display: 'flex', justifyContent: "space-between", paddingLeft: 11, paddingRight: 11, alignItems: "center", gap: 8 }}>
                                  <p className="noMargin" style={{ color: "white", lineHeight: '100%' }}>{inputItem.collection.name}</p>
                                  {companyData.type !== 'collection' &&
                                    <p className="noMargin" style={{ color: "white", cursor: "pointer", lineHeight: '100%' }} onClick={() => {
                                      changeInputCondition('collection', {})
                                    }}>X</p>
                                  }
                                </div>
                              }
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">처리장</td>
                          <td className="w-90">
                            <div className="d-flex align-items-center">
                              <button type="button" className="custom-btn secondary-bg border-radius-0 white-text border-none" onClick={() => {
                                modalOpen('treatment')
                              }}>
                                처리장 선택
                              </button>
                              {inputItem.treatmentList.map((item, index) => (
                                <div key={'treatment_company_' + index} style={{ minWidth: 113, height: 30, marginRight: 8, backgroundColor: '#219EBC', display: 'flex', justifyContent: "space-between", paddingLeft: 11, paddingRight: 11, alignItems: "center", gap: 8 }}>
                                  <p className="noMargin" style={{ color: "white", lineHeight: '100%' }}>{item.name}</p>
                                  <p className="noMargin" style={{ color: "white", cursor: "pointer", lineHeight: '100%' }} onClick={() => {
                                    changeInputCondition('treatmentList', inputItem.treatmentList.filter(i => i.id !== item.id))
                                  }}>X</p>
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div className="d-flex align-items-center margin-bottom-12 margin-top-38">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">계약 사본</p>
          </div>

          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약서 첨부</td>
                          <td className="w-90">
                            <input style={{ display: "none" }} type="file" id="getFile" accept="image/*" multiple="multiple" onChange={(e) => {
                              handleFileChange(e)
                            }} />
                            <label htmlFor="getFile" type="button" className="custom-btn secondary-bg border-radius-0 white-text border-none mb-0 text-center">
                              파일 선택 ({previewImages.length} / 5)
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">미리보기</td>
                          <td className="w-90">
                            <FilePreview arr={previewImages} handleDelete={deleteImage} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          {/* <div className="d-flex align-items-center margin-bottom-12 margin-top-38">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">계약 인증</p>
          </div> */}

          {/* <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        {signRows.map((index) => (
                          <tr key={'sign_row_'+index}>
                            {chunked[index].map((signItem, signIndex) => (
                              <Fragment key={'sign_item_'+index+signIndex}>
                                <td className="w-10 padding-left-8 primary-bg white-text">{signItem.companyName}<br />({signItem.companyType === 'emitter' ? '배출자' : signItem.companyType === 'collection' ? '수거업체' : '처리장'})</td>
                                <td className="w-15">
                                  <img src={Util.addHostUrl(signItem.signFile?.path)} />
                                </td>
                              </Fragment>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row> */}

          <div style={{ marginTop: 310 }} className="d-flex justify-content-between margin-bottom-25">
            <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 dark-bg white-text button-border" onClick={() => { history.push('/contract-management-screen') }}>
              목록으로 이동
            </button>
            <div className="d-flex">
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 primary-bg white-text button-border" onClick={() => {
                if (isValidated()) {
                  saveContract()
                }
              }}>
                계약 완료
              </button>
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 white-bg primary-text button-border" onClick={() => {
                if (confirm('입력을 초기화 하시겠습니까?')) {
                  resetInputCondition()
                }
              }}>
                입력 초기화
              </button>
            </div>
          </div>
        </Container>
      </div>

      <Modal title={'배출업체 선택'} show={modalShow.emitter} onHide={() => { modalClose('emitter') }} size="md">
        <div style={{ zIndex: 1, minHeight: '300px' }}>
          <div className="position-relative app-search d-none d-lg-block" style={{ padding: 0, width: 330, marginBottom: "1rem" }}>
            <input
              className="form-control"
              style={{ backgroundColor: "white", padding: "0.3rem" }}
              placeholder="검색어를 입력해주세요..."
              onChange={(e) => {
                setEmitterSearch(e.target.value)
              }}
              onKeyDown={(e) => {
                if (e.key == 'Enter') {
                  getCompanyList('emitter', setEmitterCompanyList, emitterSearch)
                }
              }}
            />
            <span onClick={() => {
              getCompanyList('emitter', setEmitterCompanyList, emitterSearch)
            }} className="fa fa-search" style={{ lineHeight: '38px', cursor: 'pointer' }} />
          </div>
          <div style={{ position: "relative", minHeight: '300px', overflowY: "auto" }}>
            <div style={{ position: "absolute", minHeight: '300px', right: 0, left: 0, overflowX: "hidden", width: '100%' }}>
              {emitterCompanyList.map((item) => {
                return (
                  <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                    onMouseOver={() => {
                      setIsHover(item.id)
                    }}
                    onMouseLeave={() => {
                      setIsHover(false)
                    }}
                    onClick={() => {
                      changeInputCondition('emitter', item)
                      modalClose('emitter')
                    }}>{item.name}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </Modal>
      <Modal title={'수거업체 선택'} show={modalShow.collection} onHide={() => { modalClose('collection') }} size="md">
        <div style={{ zIndex: 1, minHeight: '300px' }}>
          <div className="position-relative app-search d-none d-lg-block" style={{ padding: 0, width: 330, marginBottom: "1rem" }}>
            <input
              className="form-control"
              style={{ backgroundColor: "white", padding: "0.3rem" }}
              placeholder="검색어를 입력해주세요..."
              onChange={(e) => {
                setCollectionSearch(e.target.value)
              }}
              onKeyDown={(e) => {
                if (e.key == 'Enter') {
                  getCompanyList('collection', setCollectionCompanyList, collectionSearch)
                }
              }}
            />
            <span onClick={() => {
              getCompanyList('collection', setCollectionCompanyList, collectionSearch)
            }} className="fa fa-search" style={{ lineHeight: '38px', cursor: 'pointer' }} />
          </div>
          <div style={{ position: "relative", minHeight: '300px', overflowY: "auto" }}>
            <div style={{ position: "absolute", minHeight: '300px', right: 0, left: 0, overflowX: "hidden", width: '100%' }}>
              {collectionCompanyList.map((item) => {
                return (
                  <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                    onMouseOver={() => {
                      setIsHover(item.id)
                    }}
                    onMouseLeave={() => {
                      setIsHover(false)
                    }}
                    onClick={() => {
                      changeInputCondition('collection', item)
                      modalClose('collection')
                    }}>{item.name}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </Modal>
      <Modal title={'처리장 선택'} show={modalShow.treatment} onHide={() => { modalClose('treatment') }} size="md">
        <div style={{ zIndex: 1, }}>
          <div className="position-relative app-search d-none d-lg-block" style={{ padding: 0, width: 330, marginBottom: "1rem" }}>
            <input
              className="form-control"
              style={{ backgroundColor: "white", padding: "0.3rem" }}
              placeholder="검색어를 입력해주세요..."
              onChange={(e) => {
                setTreatmentSearch(e.target.value)
              }}
              onKeyDown={(e) => {
                if (e.key == 'Enter') {
                  getCompanyList('treatment', setTreatmentCompanyList, treatmentSearch)
                }
              }}
            />
            <span onClick={() => {
              getCompanyList('treatment', setTreatmentCompanyList, treatmentSearch)
            }} className="fa fa-search" style={{ lineHeight: '38px', cursor: 'pointer' }} />
          </div>

          <div style={{ position: "relative", minHeight: '300px', overflowY: "auto" }}>
            <div style={{ position: "absolute", minHeight: '300px', right: 0, left: 0, overflowX: "hidden", width: '100%' }}>
              {treatmentCompanyList.map((item) => {
                return (
                  <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                    onMouseOver={() => {
                      setIsHover(item.id)
                    }}
                    onMouseLeave={() => {
                      setIsHover(false)
                    }}
                    onClick={() => {
                      changeInputCondition('treatmentList', inputItem.treatmentList.some(v => v.name === item.name) ? inputItem.treatmentList : [...inputItem.treatmentList, item])
                      modalClose('treatment')
                    }}>{item.name}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </Modal>
      <Modal title={'본점 및 지점 선택'} show={modalShow.emitterChild} onHide={() => { modalClose('emitterChild') }} size="md">
        <div style={{ zIndex: 1, }}>

          <div style={{ position: "relative", minHeight: '300px', overflowY: "auto" }}>
            <div style={{ position: "absolute", minHeight: '300px', right: 0, left: 0, overflowX: "hidden", width: '100%' }}>
              {emitterChildCompanyList && emitterChildCompanyList.map((item) => {
                return (
                  <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                    onMouseOver={() => {
                      setIsHover(item.id)
                    }}
                    onMouseLeave={() => {
                      setIsHover(false)
                    }}
                    onClick={() => {
                      changeInputCondition('emitterChildList', inputItem.emitterChildList.some(v => v.name === item.name) ? inputItem.emitterChildList : [...inputItem.emitterChildList, item])
                      modalClose('emitterChild')
                    }}>{item.name}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </Modal>

    </React.Fragment>
  )
}

export default ContractWrite
